<template>
  <div class="step-container">
    <p class="step-title">
        <span>演示前准备</span>
        <span>{{step}}<span class="grey">/{{stepNum}}</span></span>
    </p>
    <desc-box title="配置前">
        <p>请统一登录 vip.bdsaas.com <span style="color:#0056FF;" @click="copy">&lt;复制&gt;</span></p>
    </desc-box>
    <desc-box :title="stepContent.title">
        <p>{{stepContent.content}}</p>
        <img :src="stepContent.img" alt="" style="margin-top:14px;" @click="preview([stepContent.img])">
    </desc-box>
    <desc-box title="配置后">
        <p>{{stepContent.tip}}</p>
    </desc-box>
    <div class="confirm-tip">
        <van-checkbox v-model="checked">我已确认配置完成</van-checkbox>
    </div>
    <div class="button-group">
        <van-button type="info" :disabled="!checked" v-if="step == stepNum" @click="nextStep">设置完毕</van-button>
        <div style="display: contents;" v-else>
            <van-button style="margin-right: 10px;" v-if="step != 1" @click="preStep">上一步</van-button>
            <van-button type="info" :disabled="!checked" @click="nextStep">下一步</van-button>
        </div>
    </div>
  </div>
</template>

<script>
import descBox from './descBox.vue';
import { ImagePreview } from 'vant';
export default {
    components: { descBox },
    props: {
        step: Number || String,
        stepContent: {
            type: Object,
            require: true
        },
        stepNum: Number
    },
    data() {
        return {
            checked: false
        };
    },
    watch: {
        step() {
            this.checked = false;
            window.scrollTo(0, 0);
        }
    },
    methods: {
        copy() {
            var input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', 'vip.bdsaas.com');
            input.select();
            if (document.execCommand('copy')) {
                this.$toast.success({ message: '已复制到剪切板' });
            } else {
                this.$toast.warning({ message: '该浏览器不支持自动复制' });
            }
            document.body.removeChild(input);
        },
        preStep() {
            this.$emit('changeStep', this.step - 1);
        },
        nextStep() {
            this.$emit('changeStep', this.step + 1);
        },
        preview(img) {
            ImagePreview([img]);
        }
    }
};
</script>

<style  lang="scss" scoped>
.step-container{
    background-color: #F2F5FA;
    padding-top: 22px;
    .step-title{
        margin: 0 16px 23px 20px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC, Montserrat-SemiBold, Montserrat;
        font-weight: 600;
        color: #242934;
        line-height: 28px;
        display: flex;
        justify-content: space-between;
        .grey{
            color: #9CA6B9;
        }
    }
    .confirm-tip{
        margin:24px 0 57px 24px;
        height: 13px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #646B7A;
        line-height: 13px;
        .van-checkbox__icon{
            font-size: 16px;
        }
    }
    .button-group{
        margin: 0 24px 0;
        padding-bottom: 34px;
        display: flex;
        justify-content: space-between;
        .van-button--default{
            flex-grow: 1;
            height: 48px;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #E1E4E8;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #242934;
            line-height: 48px;
            text-align: center;
        }
        .van-button--info{
            flex-grow: 1;
            height: 48px;
            background: #0056FF;
            border-radius: 8px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 48px;
            text-align: center;
        }
    }
}
</style>
